module.exports = __webpack_public_path__ + "img/20230731161129330vdt.de29ff77.png";